export default __webpack_public_path__ + "static/media/Spin torre RI_Interactive LightMix0007.cb872496.webp";